export const mediaCycles = [
  {
    "id": "cycle-1",
    "slug": {
      "en": "cycle-1-the-foundation",
      "es": "cycle-1-the-foundation",
      "nl": "cycle-1-the-foundation",
      "pap": "cycle-1-the-foundation"
    },
    "title": {
      "en": "Cycle 1 - Ma'at: The Foundation",
      "es": "Ciclo 1 - Ma'at: El Fundamento",
      "nl": "Cyclus 1 - Ma'at: Het Fundament",
      "pap": "Siklo 1 - Ma'at: E Fundeshi"
    },
    "canonName": {
      "en": "The Awakening of Mind",
      "es": "El Despertar de la Mente",
      "nl": "Het Ontwaken van de Geest",
      "pap": "E Spièrtamentu di Mente"
    },
    "status": "active",
    "image": "/assets/images/cycle-maat-realistic.png",
    "imageAlt": "Realistic image of Ma'at for Cycle 1",
    "description": {
      "en": "Cycle 1: the student forms a coherent map of deeper reality. Master question: What is the deeper structure of reality, and how do I live in alignment with it?",
      "es": "Ciclo 1: el estudiante forma un mapa coherente de la realidad profunda. Pregunta maestra: ¿cuál es la estructura más profunda de la realidad y cómo vivo en armonía con ella?",
      "nl": "Cyclus 1: de student vormt een samenhangende kaart van de diepere werkelijkheid. Kernvraag: wat is de diepere structuur van de werkelijkheid, en hoe leef ik daarmee in overeenstemming?",
      "pap": "Siklo 1: e studiante ta forma un mapa koherente di e realidat mas profundo. Pregunta prinsipal: kua ta e struktura mas profundo di realidat, i kon mi ta biba na armonia kuné?"
    },
    "seasons": [
      {
        "id": "cycle-1-season-1",
        "slug": {
          "en": "eigen-pad-season-1-threshold",
          "es": "eigen-pad-season-1-threshold",
          "nl": "eigen-pad-season-1-threshold",
          "pap": "eigen-pad-season-1-threshold"
        },
        "sourcePage": "media-2.html",
        "title": {
          "en": "Eigen Pad / Season 1 - Threshold: Kybalion",
          "es": "Eigen Pad / Temporada 1 - Umbral: Kybalion",
          "nl": "Eigen Pad / Seizoen 1 - Drempel: Kybalion",
          "pap": "Eigen Pad / Temporada 1 - Umbral: Kybalion"
        },
        "subtitle": {
          "en": "The 7 Principles of a Moral Society",
          "es": "Los 7 Principios de una Sociedad Moral",
          "nl": "De 7 Principes v/e Morele Samenleving",
          "pap": "E 7 Prinsipionan di un Sosiedat Moral"
        },
        "canonMovement": {
          "en": "Threshold",
          "es": "Umbral",
          "nl": "Drempel",
          "pap": "Umbral"
        },
        "description": {
          "en": "Wab begins. The season introduces the master question, awakens attention, and disturbs inherited assumptions.",
          "es": "Wab comienza. La temporada presenta la pregunta maestra, despierta la atención y sacude las suposiciones heredadas.",
          "nl": "Wab begint. Het seizoen introduceert de kernvraag, wekt de aandacht en verstoort overgeërfde aannames.",
          "pap": "Wab ta kuminsá. E temporada ta introdusí e pregunta prinsipal, ta spièrta atenshon i ta sakudí suposishonnan eredá."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-1-season-2",
        "slug": {
          "en": "eigen-pad-season-2-descent",
          "es": "eigen-pad-season-2-descent",
          "nl": "eigen-pad-season-2-descent",
          "pap": "eigen-pad-season-2-descent"
        },
        "sourcePage": "media-3.html",
        "title": {
          "en": "Eigen Pad / Season 2 - Descent: The Matrix Decoded",
          "es": "Eigen Pad / Temporada 2 - Descenso: La Matrix Decodificada",
          "nl": "Eigen Pad / Seizoen 2 - Afdaling: De Matrix Gedecodeerd",
          "pap": "Eigen Pad / Temporada 2 - Bahada: E Matrix Dekodifiká"
        },
        "subtitle": {
          "en": "The Matrix Decoded",
          "es": "La Matrix Decodificada",
          "nl": "De Matrix Gedecodeerd",
          "pap": "E Matrix Dekodifiká"
        },
        "canonMovement": {
          "en": "Descent",
          "es": "Descenso",
          "nl": "Afdaling",
          "pap": "Bahada"
        },
        "description": {
          "en": "Sia is challenged. The student enters complexity and faces the first crisis of understanding.",
          "es": "Sia es puesto a prueba. El estudiante entra en la complejidad y enfrenta la primera crisis de comprensión.",
          "nl": "Sia wordt uitgedaagd. De student betreedt de complexiteit en ervaart de eerste begripscrisis.",
          "pap": "Sia ta wòrdu desafiá. E studiante ta drenta den kompleksidat i ta enfrentá e promé krisis di komprondementu."
        },
        "image": "/assets/images/bg-matrix.jpg",
        "imageAlt": "Matrix background"
      },
      {
        "id": "cycle-1-season-3",
        "slug": {
          "en": "eigen-pad-season-3-foundation",
          "es": "eigen-pad-season-3-foundation",
          "nl": "eigen-pad-season-3-foundation",
          "pap": "eigen-pad-season-3-foundation"
        },
        "sourcePage": "media-4.html",
        "title": {
          "en": "Eigen Pad / Season 3 - Foundation: Kabbalah",
          "es": "Eigen Pad / Temporada 3 - Fundamento: Cábala",
          "nl": "Eigen Pad / Seizoen 3 - Fundament: Kabbala",
          "pap": "Eigen Pad / Temporada 3 - Fundeshi: Kabala"
        },
        "subtitle": {
          "en": "TAROT I - Kabbalah & Tarot Revealed.",
          "es": "TAROT I - Cábala y Tarot Revelados.",
          "nl": "TAROT I - Kabbala & Tarot Onthuld.",
          "pap": "TAROT I - Kabala & Tarot Revelá."
        },
        "canonMovement": {
          "en": "Foundation",
          "es": "Fundamento",
          "nl": "Fundament",
          "pap": "Fundeshi"
        },
        "description": {
          "en": "Ren begins to reveal. The season exposes the deep structure on which the rest of the cycle rests.",
          "es": "Ren comienza a revelar. La temporada expone la estructura profunda sobre la que descansa el resto del ciclo.",
          "nl": "Ren begint te onthullen. Het seizoen legt de diepe structuur bloot waarop de rest van de cyclus rust.",
          "pap": "Ren ta kuminsá revelá. E temporada ta mustra e struktura profundo riba kua e resto di e siklo ta sostené."
        },
        "image": "/assets/images/kabbala-tarot-bg.jpg",
        "imageAlt": "Kabbala and Tarot background"
      },
      {
        "id": "cycle-1-season-4",
        "slug": {
          "en": "eigen-pad-season-4-the-map",
          "es": "eigen-pad-season-4-the-map",
          "nl": "eigen-pad-season-4-the-map",
          "pap": "eigen-pad-season-4-the-map"
        },
        "sourcePage": "media-5.html",
        "title": {
          "en": "Eigen Pad / Season 4 - The Map: Tarot",
          "es": "Eigen Pad / Temporada 4 - El Mapa: Tarot",
          "nl": "Eigen Pad / Seizoen 4 - De Kaart: Tarot",
          "pap": "Eigen Pad / Temporada 4 - E Mapa: Tarot"
        },
        "subtitle": {
          "en": "TAROT II - The Ever-Rising Son/Sun",
          "es": "TAROT II - El Hijo/Sol Siempre Naciente",
          "nl": "TAROT II - De Steeds Opk. Zo(o)n.",
          "pap": "TAROT II - E Yu/Solo Semper Sali"
        },
        "canonMovement": {
          "en": "The Map",
          "es": "El Mapa",
          "nl": "De Kaart",
          "pap": "E Mapa"
        },
        "description": {
          "en": "Ib gains orientation. The season gives a navigational system for the symbolic and interior world.",
          "es": "Ib obtiene orientación. La temporada ofrece un sistema de navegación para el mundo simbólico e interior.",
          "nl": "Ib krijgt oriëntatie. Het seizoen biedt een navigatiesysteem voor de symbolische en innerlijke wereld.",
          "pap": "Ib ta haña orientashon. E temporada ta duna un sistema di navegashon pa e mundu simbóliko i interno."
        },
        "image": "/assets/images/sekhmet.png",
        "imageAlt": "Sekhmet image"
      },
      {
        "id": "cycle-1-season-5",
        "slug": {
          "en": "eigen-pad-season-5-the-shadow",
          "es": "eigen-pad-season-5-the-shadow",
          "nl": "eigen-pad-season-5-the-shadow",
          "pap": "eigen-pad-season-5-the-shadow"
        },
        "sourcePage": "media-6.html",
        "title": {
          "en": "Eigen Pad / Season 5 - The Shadow: Occult Side of the Bible",
          "es": "Eigen Pad / Temporada 5 - La Sombra: El Lado Oculto de la Biblia",
          "nl": "Eigen Pad / Seizoen 5 - De Schaduw: De Occulte Kant van de Bijbel",
          "pap": "Eigen Pad / Temporada 5 - E Sombra: E Banda Okulto di Beibel"
        },
        "subtitle": {
          "en": "The Occult Side of the Bible",
          "es": "El Lado Oculto de la Biblia",
          "nl": "De Occulte Kant van de Bijbel",
          "pap": "E Banda Okulto di Beibel"
        },
        "canonMovement": {
          "en": "The Shadow",
          "es": "La Sombra",
          "nl": "De Schaduw",
          "pap": "E Sombra"
        },
        "description": {
          "en": "Deeper Wab. The season addresses hidden, suppressed, or reversed knowledge.",
          "es": "Wab más profundo. La temporada aborda el conocimiento oculto, suprimido o invertido.",
          "nl": "Diepere Wab. Het seizoen behandelt verborgen, onderdrukte of omgekeerde kennis.",
          "pap": "Wab mas profundo. E temporada ta trata konosementu skondí, suprimí òf invertí."
        },
        "image": "/assets/images/holy_lance.png",
        "imageAlt": "Holy Lance image"
      },
      {
        "id": "cycle-1-season-6",
        "slug": {
          "en": "eigen-pad-season-6-the-myth",
          "es": "eigen-pad-season-6-the-myth",
          "nl": "eigen-pad-season-6-the-myth",
          "pap": "eigen-pad-season-6-the-myth"
        },
        "sourcePage": "media-7.html",
        "title": {
          "en": "Eigen Pad / Season 6 - The Myth: Gilgamesh",
          "es": "Eigen Pad / Temporada 6 - El Mito: Gilgamesh",
          "nl": "Eigen Pad / Seizoen 6 - De Mythe: Gilgamesj",
          "pap": "Eigen Pad / Temporada 6 - E Mito: Gilgamesh"
        },
        "subtitle": {
          "en": "The Epic of Gilgamesh",
          "es": "La Epopeya de Gilgamesh",
          "nl": "Het Gilgamesj-Epos",
          "pap": "E Epopeya di Gilgamesh"
        },
        "canonMovement": {
          "en": "The Myth",
          "es": "El Mito",
          "nl": "De Mythe",
          "pap": "E Mito"
        },
        "description": {
          "en": "Ba becomes mobile across layers. The season reads the human story, eternal pattern, and self as archetype.",
          "es": "Ba se vuelve móvil entre las capas. La temporada lee la historia humana, el patrón eterno y el yo como arquetipo.",
          "nl": "Ba wordt beweeglijk doorheen de lagen. Het seizoen leest het menselijke verhaal, het eeuwige patroon en het zelf als archetype.",
          "pap": "Ba ta bira móbil dor di e kapanan. E temporada ta lesa e historia humano, e patronchi eterno, i e mes komo arketipo."
        },
        "image": "/assets/images/gilgamesh.png",
        "imageAlt": "Gilgamesh image"
      },
      {
        "id": "cycle-1-season-7",
        "slug": {
          "en": "eigen-pad-season-7-the-law",
          "es": "eigen-pad-season-7-the-law",
          "nl": "eigen-pad-season-7-the-law",
          "pap": "eigen-pad-season-7-the-law"
        },
        "sourcePage": null,
        "title": {
          "en": "Eigen Pad / Season 7 - The Law: The 12 Laws of the Ntrw",
          "es": "Eigen Pad / Temporada 7 - La Ley: Las 12 Leyes de los Ntrw",
          "nl": "Eigen Pad / Seizoen 7 - De Wet: De 12 Wetten van de Ntrw",
          "pap": "Eigen Pad / Temporada 7 - E Lei: E 12 Leinan di e Ntrw"
        },
        "subtitle": {
          "en": "The 12 Laws of the Ntrw",
          "es": "Las 12 Leyes de los Ntrw",
          "nl": "De 12 Wetten van de Ntrw",
          "pap": "E 12 Leinan di e Ntrw"
        },
        "canonMovement": {
          "en": "The Law",
          "es": "La Ley",
          "nl": "De Wet",
          "pap": "E Lei"
        },
        "description": {
          "en": "Hu, Heka, and Ma'a Kheru synthesis. Reserved for the universal principle and new right relationship that complete Cycle 1.",
          "es": "Síntesis de Hu, Heka y Ma'a Kheru. Reservado para el principio universal y la nueva relación correcta que completan el Ciclo 1.",
          "nl": "Synthese van Hu, Heka en Ma'a Kheru. Gereserveerd voor het universele principe en de nieuwe juiste verhouding die Cyclus 1 voltooien.",
          "pap": "Síntesis di Hu, Heka i Ma'a Kheru. Reservá pa e prinsipio universal i e nobo relashon korekto ku ta kompletá Siklo 1."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      }
    ]
  },
  {
    "id": "cycle-2",
    "slug": {
      "en": "cycle-2-cycle-2-ptah-the-practice",
      "es": "cycle-2-cycle-2-ptah-the-practice",
      "nl": "cycle-2-cycle-2-ptah-the-practice",
      "pap": "cycle-2-cycle-2-ptah-the-practice"
    },
    "title": {
      "en": "Cycle 2 - Ptah: The Practice",
      "es": "Ciclo 2 - Ptah: La Práctica",
      "nl": "Cyclus 2 - Ptah: De Praktijk",
      "pap": "Siklo 2 - Ptah: E Práktika"
    },
    "status": "planned",
    "image": "/assets/images/cycle-ptah-realistic.png",
    "imageAlt": "Realistic image of Ptah for Cycle 2",
    "description": {
      "en": "The student moves from map to practice; principles are applied to life.",
      "es": "El estudiante pasa del mapa a la práctica; los principios se aplican a la vida.",
      "nl": "De student gaat van kaart naar praktijk; principes worden toegepast op het leven.",
      "pap": "E studiante ta pasa di mapa pa práktika; prinsipionan ta wòrdu apliká na bida."
    },
    "seasons": [
      {
        "id": "cycle-2-season-1",
        "slug": {
          "en": "cycle-2-season-1",
          "es": "cycle-2-season-1",
          "nl": "cycle-2-season-1",
          "pap": "cycle-2-season-1"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 2 / Season 1",
          "es": "Ciclo 2 / Temporada 1",
          "nl": "Cyclus 2 / Seizoen 1",
          "pap": "Siklo 2 / Temporada 1"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Threshold",
          "es": "Umbral",
          "nl": "Drempel",
          "pap": "Umbral"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-2-season-2",
        "slug": {
          "en": "cycle-2-season-2",
          "es": "cycle-2-season-2",
          "nl": "cycle-2-season-2",
          "pap": "cycle-2-season-2"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 2 / Season 2",
          "es": "Ciclo 2 / Temporada 2",
          "nl": "Cyclus 2 / Seizoen 2",
          "pap": "Siklo 2 / Temporada 2"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Descent",
          "es": "Descenso",
          "nl": "Afdaling",
          "pap": "Bahada"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-2-season-3",
        "slug": {
          "en": "cycle-2-season-3",
          "es": "cycle-2-season-3",
          "nl": "cycle-2-season-3",
          "pap": "cycle-2-season-3"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 2 / Season 3",
          "es": "Ciclo 2 / Temporada 3",
          "nl": "Cyclus 2 / Seizoen 3",
          "pap": "Siklo 2 / Temporada 3"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Foundation",
          "es": "Fundamento",
          "nl": "Fundament",
          "pap": "Fundeshi"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-2-season-4",
        "slug": {
          "en": "cycle-2-season-4",
          "es": "cycle-2-season-4",
          "nl": "cycle-2-season-4",
          "pap": "cycle-2-season-4"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 2 / Season 4",
          "es": "Ciclo 2 / Temporada 4",
          "nl": "Cyclus 2 / Seizoen 4",
          "pap": "Siklo 2 / Temporada 4"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Map",
          "es": "El Mapa",
          "nl": "De Kaart",
          "pap": "E Mapa"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-2-season-5",
        "slug": {
          "en": "cycle-2-season-5",
          "es": "cycle-2-season-5",
          "nl": "cycle-2-season-5",
          "pap": "cycle-2-season-5"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 2 / Season 5",
          "es": "Ciclo 2 / Temporada 5",
          "nl": "Cyclus 2 / Seizoen 5",
          "pap": "Siklo 2 / Temporada 5"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Shadow",
          "es": "La Sombra",
          "nl": "De Schaduw",
          "pap": "E Sombra"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-2-season-6",
        "slug": {
          "en": "cycle-2-season-6",
          "es": "cycle-2-season-6",
          "nl": "cycle-2-season-6",
          "pap": "cycle-2-season-6"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 2 / Season 6",
          "es": "Ciclo 2 / Temporada 6",
          "nl": "Cyclus 2 / Seizoen 6",
          "pap": "Siklo 2 / Temporada 6"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Myth",
          "es": "El Mito",
          "nl": "De Mythe",
          "pap": "E Mito"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-2-season-7",
        "slug": {
          "en": "cycle-2-season-7",
          "es": "cycle-2-season-7",
          "nl": "cycle-2-season-7",
          "pap": "cycle-2-season-7"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 2 / Season 7",
          "es": "Ciclo 2 / Temporada 7",
          "nl": "Cyclus 2 / Seizoen 7",
          "pap": "Siklo 2 / Temporada 7"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Law",
          "es": "La Ley",
          "nl": "De Wet",
          "pap": "E Lei"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      }
    ]
  },
  {
    "id": "cycle-3",
    "slug": {
      "en": "cycle-3-cycle-3-isis-the-integration",
      "es": "cycle-3-cycle-3-isis-the-integration",
      "nl": "cycle-3-cycle-3-isis-the-integration",
      "pap": "cycle-3-cycle-3-isis-the-integration"
    },
    "title": {
      "en": "Cycle 3 - Isis: The Integration",
      "es": "Ciclo 3 - Isis: La Integración",
      "nl": "Cyclus 3 - Isis: De Integratie",
      "pap": "Siklo 3 - Isis: E Integrashon"
    },
    "status": "planned",
    "image": "/assets/images/cycle-isis-realistic.png",
    "imageAlt": "Realistic image of Isis for Cycle 3",
    "description": {
      "en": "The student experiences genuine transformation; principles begin to live in the body.",
      "es": "El estudiante experimenta una transformación genuina; los principios comienzan a vivir en el cuerpo.",
      "nl": "De student ervaart echte transformatie; principes gaan in het lichaam leven.",
      "pap": "E studiante ta eksperensiá un transformashon berdadero; prinsipionan ta kuminsá biba den e kurpa."
    },
    "seasons": [
      {
        "id": "cycle-3-season-1",
        "slug": {
          "en": "cycle-3-season-1",
          "es": "cycle-3-season-1",
          "nl": "cycle-3-season-1",
          "pap": "cycle-3-season-1"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 3 / Season 1",
          "es": "Ciclo 3 / Temporada 1",
          "nl": "Cyclus 3 / Seizoen 1",
          "pap": "Siklo 3 / Temporada 1"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Threshold",
          "es": "Umbral",
          "nl": "Drempel",
          "pap": "Umbral"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-3-season-2",
        "slug": {
          "en": "cycle-3-season-2",
          "es": "cycle-3-season-2",
          "nl": "cycle-3-season-2",
          "pap": "cycle-3-season-2"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 3 / Season 2",
          "es": "Ciclo 3 / Temporada 2",
          "nl": "Cyclus 3 / Seizoen 2",
          "pap": "Siklo 3 / Temporada 2"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Descent",
          "es": "Descenso",
          "nl": "Afdaling",
          "pap": "Bahada"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-3-season-3",
        "slug": {
          "en": "cycle-3-season-3",
          "es": "cycle-3-season-3",
          "nl": "cycle-3-season-3",
          "pap": "cycle-3-season-3"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 3 / Season 3",
          "es": "Ciclo 3 / Temporada 3",
          "nl": "Cyclus 3 / Seizoen 3",
          "pap": "Siklo 3 / Temporada 3"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Foundation",
          "es": "Fundamento",
          "nl": "Fundament",
          "pap": "Fundeshi"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-3-season-4",
        "slug": {
          "en": "cycle-3-season-4",
          "es": "cycle-3-season-4",
          "nl": "cycle-3-season-4",
          "pap": "cycle-3-season-4"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 3 / Season 4",
          "es": "Ciclo 3 / Temporada 4",
          "nl": "Cyclus 3 / Seizoen 4",
          "pap": "Siklo 3 / Temporada 4"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Map",
          "es": "El Mapa",
          "nl": "De Kaart",
          "pap": "E Mapa"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-3-season-5",
        "slug": {
          "en": "cycle-3-season-5",
          "es": "cycle-3-season-5",
          "nl": "cycle-3-season-5",
          "pap": "cycle-3-season-5"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 3 / Season 5",
          "es": "Ciclo 3 / Temporada 5",
          "nl": "Cyclus 3 / Seizoen 5",
          "pap": "Siklo 3 / Temporada 5"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Shadow",
          "es": "La Sombra",
          "nl": "De Schaduw",
          "pap": "E Sombra"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-3-season-6",
        "slug": {
          "en": "cycle-3-season-6",
          "es": "cycle-3-season-6",
          "nl": "cycle-3-season-6",
          "pap": "cycle-3-season-6"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 3 / Season 6",
          "es": "Ciclo 3 / Temporada 6",
          "nl": "Cyclus 3 / Seizoen 6",
          "pap": "Siklo 3 / Temporada 6"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Myth",
          "es": "El Mito",
          "nl": "De Mythe",
          "pap": "E Mito"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-3-season-7",
        "slug": {
          "en": "cycle-3-season-7",
          "es": "cycle-3-season-7",
          "nl": "cycle-3-season-7",
          "pap": "cycle-3-season-7"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 3 / Season 7",
          "es": "Ciclo 3 / Temporada 7",
          "nl": "Cyclus 3 / Seizoen 7",
          "pap": "Siklo 3 / Temporada 7"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Law",
          "es": "La Ley",
          "nl": "De Wet",
          "pap": "E Lei"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      }
    ]
  },
  {
    "id": "cycle-4",
    "slug": {
      "en": "cycle-4-cycle-4-set-the-crisis-of-mastery",
      "es": "cycle-4-cycle-4-set-the-crisis-of-mastery",
      "nl": "cycle-4-cycle-4-set-the-crisis-of-mastery",
      "pap": "cycle-4-cycle-4-set-the-crisis-of-mastery"
    },
    "title": {
      "en": "Cycle 4 - Set: The Crisis of Mastery",
      "es": "Ciclo 4 - Set: La Crisis de la Maestría",
      "nl": "Cyclus 4 - Set: De Crisis van Meesterschap",
      "pap": "Siklo 4 - Set: E Krisis di Maestria"
    },
    "status": "planned",
    "image": "/assets/images/cycle-set-realistic.png",
    "imageAlt": "Realistic image of Set for Cycle 4",
    "description": {
      "en": "The student encounters the limitations of the entire system; the true dark night.",
      "es": "El estudiante encuentra los límites de todo el sistema; la verdadera noche oscura.",
      "nl": "De student stuit op de grenzen van het hele systeem; de ware donkere nacht.",
      "pap": "E studiante ta topa e limitashonnan di henter e sistema; e berdadero anochi skur."
    },
    "seasons": [
      {
        "id": "cycle-4-season-1",
        "slug": {
          "en": "cycle-4-season-1",
          "es": "cycle-4-season-1",
          "nl": "cycle-4-season-1",
          "pap": "cycle-4-season-1"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 4 / Season 1",
          "es": "Ciclo 4 / Temporada 1",
          "nl": "Cyclus 4 / Seizoen 1",
          "pap": "Siklo 4 / Temporada 1"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Threshold",
          "es": "Umbral",
          "nl": "Drempel",
          "pap": "Umbral"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-4-season-2",
        "slug": {
          "en": "cycle-4-season-2",
          "es": "cycle-4-season-2",
          "nl": "cycle-4-season-2",
          "pap": "cycle-4-season-2"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 4 / Season 2",
          "es": "Ciclo 4 / Temporada 2",
          "nl": "Cyclus 4 / Seizoen 2",
          "pap": "Siklo 4 / Temporada 2"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Descent",
          "es": "Descenso",
          "nl": "Afdaling",
          "pap": "Bahada"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-4-season-3",
        "slug": {
          "en": "cycle-4-season-3",
          "es": "cycle-4-season-3",
          "nl": "cycle-4-season-3",
          "pap": "cycle-4-season-3"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 4 / Season 3",
          "es": "Ciclo 4 / Temporada 3",
          "nl": "Cyclus 4 / Seizoen 3",
          "pap": "Siklo 4 / Temporada 3"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Foundation",
          "es": "Fundamento",
          "nl": "Fundament",
          "pap": "Fundeshi"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-4-season-4",
        "slug": {
          "en": "cycle-4-season-4",
          "es": "cycle-4-season-4",
          "nl": "cycle-4-season-4",
          "pap": "cycle-4-season-4"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 4 / Season 4",
          "es": "Ciclo 4 / Temporada 4",
          "nl": "Cyclus 4 / Seizoen 4",
          "pap": "Siklo 4 / Temporada 4"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Map",
          "es": "El Mapa",
          "nl": "De Kaart",
          "pap": "E Mapa"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-4-season-5",
        "slug": {
          "en": "cycle-4-season-5",
          "es": "cycle-4-season-5",
          "nl": "cycle-4-season-5",
          "pap": "cycle-4-season-5"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 4 / Season 5",
          "es": "Ciclo 4 / Temporada 5",
          "nl": "Cyclus 4 / Seizoen 5",
          "pap": "Siklo 4 / Temporada 5"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Shadow",
          "es": "La Sombra",
          "nl": "De Schaduw",
          "pap": "E Sombra"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-4-season-6",
        "slug": {
          "en": "cycle-4-season-6",
          "es": "cycle-4-season-6",
          "nl": "cycle-4-season-6",
          "pap": "cycle-4-season-6"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 4 / Season 6",
          "es": "Ciclo 4 / Temporada 6",
          "nl": "Cyclus 4 / Seizoen 6",
          "pap": "Siklo 4 / Temporada 6"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Myth",
          "es": "El Mito",
          "nl": "De Mythe",
          "pap": "E Mito"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-4-season-7",
        "slug": {
          "en": "cycle-4-season-7",
          "es": "cycle-4-season-7",
          "nl": "cycle-4-season-7",
          "pap": "cycle-4-season-7"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 4 / Season 7",
          "es": "Ciclo 4 / Temporada 7",
          "nl": "Cyclus 4 / Seizoen 7",
          "pap": "Siklo 4 / Temporada 7"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Law",
          "es": "La Ley",
          "nl": "De Wet",
          "pap": "E Lei"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      }
    ]
  },
  {
    "id": "cycle-5",
    "slug": {
      "en": "cycle-5-cycle-5-ra-the-emergence",
      "es": "cycle-5-cycle-5-ra-the-emergence",
      "nl": "cycle-5-cycle-5-ra-the-emergence",
      "pap": "cycle-5-cycle-5-ra-the-emergence"
    },
    "title": {
      "en": "Cycle 5 - Ra: The Emergence",
      "es": "Ciclo 5 - Ra: El Surgimiento",
      "nl": "Cyclus 5 - Ra: De Opkomst",
      "pap": "Siklo 5 - Ra: E Surgimentu"
    },
    "status": "planned",
    "image": "/assets/images/cycle-ra-realistic.png",
    "imageAlt": "Realistic image of Ra for Cycle 5",
    "description": {
      "en": "The student becomes primarily a practitioner and serves others from lived experience.",
      "es": "El estudiante se convierte ante todo en practicante y sirve a los demás desde la experiencia vivida.",
      "nl": "De student wordt vooral een beoefenaar en dient anderen vanuit geleefde ervaring.",
      "pap": "E studiante ta bira prinsipalmente un praktikante i ta sirbi otronan for di eksperensia bibí."
    },
    "seasons": [
      {
        "id": "cycle-5-season-1",
        "slug": {
          "en": "cycle-5-season-1",
          "es": "cycle-5-season-1",
          "nl": "cycle-5-season-1",
          "pap": "cycle-5-season-1"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 5 / Season 1",
          "es": "Ciclo 5 / Temporada 1",
          "nl": "Cyclus 5 / Seizoen 1",
          "pap": "Siklo 5 / Temporada 1"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Threshold",
          "es": "Umbral",
          "nl": "Drempel",
          "pap": "Umbral"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-5-season-2",
        "slug": {
          "en": "cycle-5-season-2",
          "es": "cycle-5-season-2",
          "nl": "cycle-5-season-2",
          "pap": "cycle-5-season-2"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 5 / Season 2",
          "es": "Ciclo 5 / Temporada 2",
          "nl": "Cyclus 5 / Seizoen 2",
          "pap": "Siklo 5 / Temporada 2"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Descent",
          "es": "Descenso",
          "nl": "Afdaling",
          "pap": "Bahada"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-5-season-3",
        "slug": {
          "en": "cycle-5-season-3",
          "es": "cycle-5-season-3",
          "nl": "cycle-5-season-3",
          "pap": "cycle-5-season-3"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 5 / Season 3",
          "es": "Ciclo 5 / Temporada 3",
          "nl": "Cyclus 5 / Seizoen 3",
          "pap": "Siklo 5 / Temporada 3"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Foundation",
          "es": "Fundamento",
          "nl": "Fundament",
          "pap": "Fundeshi"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-5-season-4",
        "slug": {
          "en": "cycle-5-season-4",
          "es": "cycle-5-season-4",
          "nl": "cycle-5-season-4",
          "pap": "cycle-5-season-4"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 5 / Season 4",
          "es": "Ciclo 5 / Temporada 4",
          "nl": "Cyclus 5 / Seizoen 4",
          "pap": "Siklo 5 / Temporada 4"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Map",
          "es": "El Mapa",
          "nl": "De Kaart",
          "pap": "E Mapa"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-5-season-5",
        "slug": {
          "en": "cycle-5-season-5",
          "es": "cycle-5-season-5",
          "nl": "cycle-5-season-5",
          "pap": "cycle-5-season-5"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 5 / Season 5",
          "es": "Ciclo 5 / Temporada 5",
          "nl": "Cyclus 5 / Seizoen 5",
          "pap": "Siklo 5 / Temporada 5"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Shadow",
          "es": "La Sombra",
          "nl": "De Schaduw",
          "pap": "E Sombra"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-5-season-6",
        "slug": {
          "en": "cycle-5-season-6",
          "es": "cycle-5-season-6",
          "nl": "cycle-5-season-6",
          "pap": "cycle-5-season-6"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 5 / Season 6",
          "es": "Ciclo 5 / Temporada 6",
          "nl": "Cyclus 5 / Seizoen 6",
          "pap": "Siklo 5 / Temporada 6"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Myth",
          "es": "El Mito",
          "nl": "De Mythe",
          "pap": "E Mito"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-5-season-7",
        "slug": {
          "en": "cycle-5-season-7",
          "es": "cycle-5-season-7",
          "nl": "cycle-5-season-7",
          "pap": "cycle-5-season-7"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 5 / Season 7",
          "es": "Ciclo 5 / Temporada 7",
          "nl": "Cyclus 5 / Seizoen 7",
          "pap": "Siklo 5 / Temporada 7"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Law",
          "es": "La Ley",
          "nl": "De Wet",
          "pap": "E Lei"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      }
    ]
  },
  {
    "id": "cycle-6",
    "slug": {
      "en": "cycle-6-cycle-6-thoth-the-transmission",
      "es": "cycle-6-cycle-6-thoth-the-transmission",
      "nl": "cycle-6-cycle-6-thoth-the-transmission",
      "pap": "cycle-6-cycle-6-thoth-the-transmission"
    },
    "title": {
      "en": "Cycle 6 - Thoth: The Transmission",
      "es": "Ciclo 6 - Thoth: La Transmisión",
      "nl": "Cyclus 6 - Thoth: De Overdracht",
      "pap": "Siklo 6 - Thoth: E Transmishon"
    },
    "status": "planned",
    "image": "/assets/images/cycle-thoth-realistic.png",
    "imageAlt": "Realistic image of Thoth for Cycle 6",
    "description": {
      "en": "The student becomes a teacher in the deeper sense: not information, but transformation.",
      "es": "El estudiante se convierte en maestro en el sentido más profundo: no información, sino transformación.",
      "nl": "De student wordt leraar in de diepere zin: geen informatie, maar transformatie.",
      "pap": "E studiante ta bira un maestro den e sentido mas profundo: no informashon, sino transformashon."
    },
    "seasons": [
      {
        "id": "cycle-6-season-1",
        "slug": {
          "en": "cycle-6-season-1",
          "es": "cycle-6-season-1",
          "nl": "cycle-6-season-1",
          "pap": "cycle-6-season-1"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 6 / Season 1",
          "es": "Ciclo 6 / Temporada 1",
          "nl": "Cyclus 6 / Seizoen 1",
          "pap": "Siklo 6 / Temporada 1"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Threshold",
          "es": "Umbral",
          "nl": "Drempel",
          "pap": "Umbral"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-6-season-2",
        "slug": {
          "en": "cycle-6-season-2",
          "es": "cycle-6-season-2",
          "nl": "cycle-6-season-2",
          "pap": "cycle-6-season-2"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 6 / Season 2",
          "es": "Ciclo 6 / Temporada 2",
          "nl": "Cyclus 6 / Seizoen 2",
          "pap": "Siklo 6 / Temporada 2"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Descent",
          "es": "Descenso",
          "nl": "Afdaling",
          "pap": "Bahada"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-6-season-3",
        "slug": {
          "en": "cycle-6-season-3",
          "es": "cycle-6-season-3",
          "nl": "cycle-6-season-3",
          "pap": "cycle-6-season-3"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 6 / Season 3",
          "es": "Ciclo 6 / Temporada 3",
          "nl": "Cyclus 6 / Seizoen 3",
          "pap": "Siklo 6 / Temporada 3"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Foundation",
          "es": "Fundamento",
          "nl": "Fundament",
          "pap": "Fundeshi"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-6-season-4",
        "slug": {
          "en": "cycle-6-season-4",
          "es": "cycle-6-season-4",
          "nl": "cycle-6-season-4",
          "pap": "cycle-6-season-4"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 6 / Season 4",
          "es": "Ciclo 6 / Temporada 4",
          "nl": "Cyclus 6 / Seizoen 4",
          "pap": "Siklo 6 / Temporada 4"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Map",
          "es": "El Mapa",
          "nl": "De Kaart",
          "pap": "E Mapa"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-6-season-5",
        "slug": {
          "en": "cycle-6-season-5",
          "es": "cycle-6-season-5",
          "nl": "cycle-6-season-5",
          "pap": "cycle-6-season-5"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 6 / Season 5",
          "es": "Ciclo 6 / Temporada 5",
          "nl": "Cyclus 6 / Seizoen 5",
          "pap": "Siklo 6 / Temporada 5"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Shadow",
          "es": "La Sombra",
          "nl": "De Schaduw",
          "pap": "E Sombra"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-6-season-6",
        "slug": {
          "en": "cycle-6-season-6",
          "es": "cycle-6-season-6",
          "nl": "cycle-6-season-6",
          "pap": "cycle-6-season-6"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 6 / Season 6",
          "es": "Ciclo 6 / Temporada 6",
          "nl": "Cyclus 6 / Seizoen 6",
          "pap": "Siklo 6 / Temporada 6"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Myth",
          "es": "El Mito",
          "nl": "De Mythe",
          "pap": "E Mito"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-6-season-7",
        "slug": {
          "en": "cycle-6-season-7",
          "es": "cycle-6-season-7",
          "nl": "cycle-6-season-7",
          "pap": "cycle-6-season-7"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 6 / Season 7",
          "es": "Ciclo 6 / Temporada 7",
          "nl": "Cyclus 6 / Seizoen 7",
          "pap": "Siklo 6 / Temporada 7"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Law",
          "es": "La Ley",
          "nl": "De Wet",
          "pap": "E Lei"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      }
    ]
  },
  {
    "id": "cycle-7",
    "slug": {
      "en": "cycle-7-cycle-7-osiris-the-return",
      "es": "cycle-7-cycle-7-osiris-the-return",
      "nl": "cycle-7-cycle-7-osiris-the-return",
      "pap": "cycle-7-cycle-7-osiris-the-return"
    },
    "title": {
      "en": "Cycle 7 - Osiris: The Return",
      "es": "Ciclo 7 - Osiris: El Retorno",
      "nl": "Cyclus 7 - Osiris: De Terugkeer",
      "pap": "Siklo 7 - Osiris: E Bòlbementu"
    },
    "status": "planned",
    "image": "/assets/images/cycle-osiris-realistic.png",
    "imageAlt": "Realistic image of Osiris for Cycle 7",
    "description": {
      "en": "The student sees the beginning with the eyes of arrival; the spiral comes full circle at a new level.",
      "es": "El estudiante ve el comienzo con los ojos de la llegada; la espiral se completa en un nuevo nivel.",
      "nl": "De student ziet het begin met de ogen van de aankomst; de spiraal komt rond op een nieuw niveau.",
      "pap": "E studiante ta mira e komienso ku e wowonan di yegada; e spiral ta kompletá su sírkulo na un nivel nobo."
    },
    "seasons": [
      {
        "id": "cycle-7-season-1",
        "slug": {
          "en": "cycle-7-season-1",
          "es": "cycle-7-season-1",
          "nl": "cycle-7-season-1",
          "pap": "cycle-7-season-1"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 7 / Season 1",
          "es": "Ciclo 7 / Temporada 1",
          "nl": "Cyclus 7 / Seizoen 1",
          "pap": "Siklo 7 / Temporada 1"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Threshold",
          "es": "Umbral",
          "nl": "Drempel",
          "pap": "Umbral"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-7-season-2",
        "slug": {
          "en": "cycle-7-season-2",
          "es": "cycle-7-season-2",
          "nl": "cycle-7-season-2",
          "pap": "cycle-7-season-2"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 7 / Season 2",
          "es": "Ciclo 7 / Temporada 2",
          "nl": "Cyclus 7 / Seizoen 2",
          "pap": "Siklo 7 / Temporada 2"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Descent",
          "es": "Descenso",
          "nl": "Afdaling",
          "pap": "Bahada"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-7-season-3",
        "slug": {
          "en": "cycle-7-season-3",
          "es": "cycle-7-season-3",
          "nl": "cycle-7-season-3",
          "pap": "cycle-7-season-3"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 7 / Season 3",
          "es": "Ciclo 7 / Temporada 3",
          "nl": "Cyclus 7 / Seizoen 3",
          "pap": "Siklo 7 / Temporada 3"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "Foundation",
          "es": "Fundamento",
          "nl": "Fundament",
          "pap": "Fundeshi"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-7-season-4",
        "slug": {
          "en": "cycle-7-season-4",
          "es": "cycle-7-season-4",
          "nl": "cycle-7-season-4",
          "pap": "cycle-7-season-4"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 7 / Season 4",
          "es": "Ciclo 7 / Temporada 4",
          "nl": "Cyclus 7 / Seizoen 4",
          "pap": "Siklo 7 / Temporada 4"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Map",
          "es": "El Mapa",
          "nl": "De Kaart",
          "pap": "E Mapa"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-7-season-5",
        "slug": {
          "en": "cycle-7-season-5",
          "es": "cycle-7-season-5",
          "nl": "cycle-7-season-5",
          "pap": "cycle-7-season-5"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 7 / Season 5",
          "es": "Ciclo 7 / Temporada 5",
          "nl": "Cyclus 7 / Seizoen 5",
          "pap": "Siklo 7 / Temporada 5"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Shadow",
          "es": "La Sombra",
          "nl": "De Schaduw",
          "pap": "E Sombra"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-7-season-6",
        "slug": {
          "en": "cycle-7-season-6",
          "es": "cycle-7-season-6",
          "nl": "cycle-7-season-6",
          "pap": "cycle-7-season-6"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 7 / Season 6",
          "es": "Ciclo 7 / Temporada 6",
          "nl": "Cyclus 7 / Seizoen 6",
          "pap": "Siklo 7 / Temporada 6"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Myth",
          "es": "El Mito",
          "nl": "De Mythe",
          "pap": "E Mito"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      },
      {
        "id": "cycle-7-season-7",
        "slug": {
          "en": "cycle-7-season-7",
          "es": "cycle-7-season-7",
          "nl": "cycle-7-season-7",
          "pap": "cycle-7-season-7"
        },
        "sourcePage": null,
        "title": {
          "en": "Cycle 7 / Season 7",
          "es": "Ciclo 7 / Temporada 7",
          "nl": "Cyclus 7 / Seizoen 7",
          "pap": "Siklo 7 / Temporada 7"
        },
        "subtitle": {
          "en": "Reserved",
          "es": "Reservado",
          "nl": "Gereserveerd",
          "pap": "Reservá"
        },
        "canonMovement": {
          "en": "The Law",
          "es": "La Ley",
          "nl": "De Wet",
          "pap": "E Lei"
        },
        "description": {
          "en": "Reserved for upcoming media in this cycle.",
          "es": "Reservado para próximos materiales de esta serie.",
          "nl": "Gereserveerd voor komende media in deze reeks.",
          "pap": "Reservá pa media ku ta bin den e siklo aki."
        },
        "image": "/assets/images/eigenpad.png",
        "imageAlt": "Eigen Pad logo"
      }
    ]
  }
];

export function getAllMediaSeasons() {
  return [
    ...mediaCycles.flatMap((cycle) => cycle.seasons.map((season) => ({ ...season, cycleId: cycle.id }))),
    ...getPublicMiscMediaCollections()
  ];
}

export function getPublicMediaSeasons() {
  return [...mediaCycles[0].seasons.map((season) => ({ ...season, cycleId: mediaCycles[0].id })), ...getPublicMiscMediaCollections()];
}

export function getMediaSeasonBySlug(slug, lang = "en") {
  return getAllMediaSeasons().find((season) => season.slug?.[lang] === slug || Object.values(season.slug || {}).includes(slug));
}

export function getMediaCycleForSeason(seasonId) {
  return mediaCycles.find((cycle) => cycle.seasons.some((season) => season.id === seasonId));
}

export const legacyMediaCollections = [
  {
    "id": "pika-pika",
    "slug": {
      "en": "pika-pika-talkshow",
      "es": "pika-pika-talkshow",
      "nl": "pika-pika-talkshow",
      "pap": "pika-pika-talkshow"
    },
    "collectionType": "misc",
    "sourcePage": "media-pika.html",
    "title": {
      "en": "Pika Pika Talkshow",
      "es": "Pika Pika Talkshow",
      "nl": "Pika Pika Talkshow",
      "pap": "Pika Pika Talkshow"
    },
    "subtitle": {
      "en": "Standalone talkshow appearances",
      "es": "Apariciones independientes en programas de entrevistas",
      "nl": "Losse talkshowoptredens",
      "pap": "Aparishonnan apart den talkshow"
    },
    "canonMovement": {
      "en": "Other media",
      "es": "Otros materiales",
      "nl": "Overige media",
      "pap": "Otro media"
    },
    "description": {
      "en": "All TGWE appearances on the Pika Pika Talkshow, in chronological order.",
      "es": "Todas las apariciones de TGWE en el Pika Pika Talkshow, en orden cronológico.",
      "nl": "Alle TGWE-optredens in de Pika Pika Talkshow, in chronologische volgorde.",
      "pap": "Tur aparishon di TGWE den e Pika Pika Talkshow, na òrden kronológiko."
    },
    "image": "/assets/images/pika.png",
    "imageAlt": "Pika Pika logo"
  },
  {
    "id": "videos",
    "slug": {
      "en": "other-videos",
      "es": "other-videos",
      "nl": "other-videos",
      "pap": "other-videos"
    },
    "collectionType": "misc",
    "sourcePage": "media-videos.html",
    "title": {
      "en": "Other videos",
      "es": "Otros videos",
      "nl": "Andere video's",
      "pap": "Otro vídeonan"
    },
    "subtitle": {
      "en": "Standalone interviews and lessons",
      "es": "Entrevistas y lecciones independientes",
      "nl": "Losse interviews en lessen",
      "pap": "Entrevistanan i lèsnan apart"
    },
    "canonMovement": {
      "en": "Other media",
      "es": "Otros materiales",
      "nl": "Overige media",
      "pap": "Otro media"
    },
    "description": {
      "en": "Interviews on other platforms plus standalone lessons on occultism, natural law, consciousness, mysticism, and related subjects.",
      "es": "Entrevistas en otras plataformas y lecciones independientes sobre ocultismo, ley natural, conciencia, misticismo y temas relacionados.",
      "nl": "Interviews op andere platforms plus losse lessen over occultisme, natuurwet, bewustzijn, mystiek en verwante onderwerpen.",
      "pap": "Entrevistanan riba otro plataforma plus lèsnan apart tokante okultismo, lei natural, konsenshi, mistisismo i tópikonan relashoná."
    },
    "image": "/assets/images/filmrollen.jpg",
    "imageAlt": "Film rolls"
  },
  {
    "id": "live-shows",
    "sourcePage": "media-live.html",
    "title": {
      "en": "Live Shows",
      "es": "Transmisiones en vivo",
      "nl": "Liveshows",
      "pap": "Show na bibo"
    },
    "description": {
      "en": "Here you can find live shows. All related to the occult and mysticism.",
      "es": "Aquí encontrarás transmisiones en vivo, todas relacionadas con lo oculto y el misticismo.",
      "nl": "Hier vind je liveshows, allemaal over het occulte en de mystiek.",
      "pap": "Akinan bo ta haña show na bibo, tur relashoná ku okulto i mistisismo."
    },
    "image": "/assets/images/live-media.png",
    "imageAlt": "Live media"
  }
];

export function getPublicMiscMediaCollections() {
  return legacyMediaCollections
    .filter((collection) => ["pika-pika", "videos"].includes(collection.id))
    .map((collection) => ({ ...collection, cycleId: "misc" }));
}
